import React, { useMemo } from 'react';
import {
  Flex, Grid, Section, Input
} from 'onefaceui-react-components';
import PropTypes from 'prop-types';

import defaultFetch from 'react/api/sagas/fetch/defaultFetch';
import BaseFormV2 from 'react/containers/layout/Crud/BaseFormV2';
import { getResourceTo } from 'react/utils/utils';
import queryClient from 'react/services/queryClient';
import { usePaymentMethodType } from 'react/queries/PaymentMethodType';

function PaymentMethodTypeForm({ id }) {
  const { data = [], isFetching } = usePaymentMethodType();

  const handleSubmit = async (values, isEdit) => {
    const { key } = values;

    const method = isEdit ? 'PATCH' : 'POST';

    const payload = { key };

    if (isEdit) {
      payload.id = id;
    }

    const response = await defaultFetch('PaymentMethodType', payload, method);

    return response;
  };

  const isEdit = useMemo(() => !!id, [id]);

  const isLoadingForm = useMemo(() => {
    if (!isEdit) return false;

    if (isEdit) return isFetching;

    return false;
  }, [isEdit, isFetching]);

  const initialData = useMemo(() => {
    const findRegister = data.find((item) => item.id === Number(id));

    if (!findRegister) return {};

    return findRegister;
  }, [data, id]);

  return (
    <BaseFormV2
      id={id}
      entity="PaymentMethodType"
      defaultValues={initialData}
      isLoading={isLoadingForm}
      saveAction={handleSubmit}
      requiredFields={['key']}
      afterSubmit={() => {
        queryClient.invalidateQueries(['payment-method-type']);
      }}
    >
      <Flex
        flexDirection="column"
        gap={16}
        dataTestId="payment-method-type-form"
      >
        <Section
          label={getResourceTo('paymentmethodtype.section.general.title')}
          hasExpandAction={false}
        >
          <Grid
            templateColumns="0.4fr"
            breakpoints={{
              md: {
                templateColumns: '0.5fr'
              }
            }}
            gap={16}
          >
            <Flex gap={16}>
              <Input
                dataTestId="key"
                label={getResourceTo('paymentmethodtype.field.key')}
                name="key"
                required
              />
            </Flex>
          </Grid>
        </Section>
      </Flex>
    </BaseFormV2>
  );
}

PaymentMethodTypeForm.propTypes = {
  id: PropTypes.string
};

PaymentMethodTypeForm.defaultProps = {
  id: null
};

export default PaymentMethodTypeForm;
